module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "mdl-layout__content"
  }, [_c('div', {
    staticClass: "page-content"
  }, [_c('h1', {
    staticClass: "mdl-typography--headline"
  }, [_vm._v("Avdelinger")]), _vm._v(" "), _c('ul', {
    staticClass: "demo-list-item mdl-list"
  }, _vm._l((_vm.departments), function(department) {
    return _c('li', {
      staticClass: "mdl-list__item"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'department',
          params: {
            id: department.id
          }
        }
      }
    }, [_c('span', {
      staticClass: "mdl-list__item-primary-content",
      domProps: {
        "textContent": _vm._s(department.id + ' ' + department.name + ' ' + department.email)
      }
    })])], 1)
  }), 0), _vm._v(" "), (_vm.$root.isEuropcarAdmin() || _vm.$root.isAdministrator()) ? _c('router-link', {
    staticClass: "mdl-button mdl-js-button mdl-button--fab mdl-js-ripple-effect mdl-button--colored",
    attrs: {
      "id": "new-assessment",
      "to": {
        name: 'new-department'
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("add")])]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79b9f70b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./reports/assets/src/components/Editor.vue
// module id = 70
// module chunks = 0